import { createFileRoute } from '@tanstack/react-router'
import { CreateContract } from '@/features/customers/components/contracts/CreateContract'

export const Route = createFileRoute(
  '/_auth/customers/$customerId/contracts/create'
)({
  component: CreateContractPage,
})

function CreateContractPage() {
  const { customerId } = Route.useParams()

  return <CreateContract customerId={customerId} />
}
